import { PowermeterHardwareModel } from 'src/State/Storage/StorageModel'

const PRODUCER_FALLBACK_TRANSLATION_KEY = 'liveView.externalProduction'
const CONSUMER_FALLBACK_TRANSLATION_KEY = 'liveView.externalConsumption'

const LABEL_INDEX = 1

interface ReturnType {
  showCustomLabel: boolean
  customLabel: string | undefined
  fallbackTranslationKey: string | undefined
}

type CustomLabelType = ReturnType & {
  showCustomLabel: true
  customLabel: string
  fallbackTranslationKey: undefined
}

type FallbackLabelType = ReturnType & {
  showCustomLabel: false
  customLabel: undefined
  fallbackTranslationKey: string
}

/**
 * This function returns a powermeter (Producer and Consumers only) custom label or a fallback translation key
 */
export const getPowermeterLiveItemLabel = (
  powermeter?: PowermeterHardwareModel[],
  isPowermeterTypeProducer?: boolean
): CustomLabelType | FallbackLabelType => {
  const fallbackTranslationKey = isPowermeterTypeProducer ? PRODUCER_FALLBACK_TRANSLATION_KEY : CONSUMER_FALLBACK_TRANSLATION_KEY

  if (!powermeter || powermeter.length > 1) return { showCustomLabel: false, customLabel: undefined, fallbackTranslationKey }

  const label = powermeter?.[0]?.name?.[LABEL_INDEX]

  if (label) return { showCustomLabel: true, customLabel: label, fallbackTranslationKey: undefined }

  return { showCustomLabel: false, customLabel: undefined, fallbackTranslationKey }
}
